import { DefaultButton } from "@fluentui/react";
import styled from "styled-components";

export const SPRow = styled.div`
.shadow{
    width: 98%;
};
& .keyboard-arrow-left{
    position: relative;
    left: -24px;
    z-index: 3;
    color: black !important;
};
& .keyboard-arrow-right{
    position: relative;
    left: -24px;
    z-index: 3;
    color: black !important;
}
`;
export const RowHeaderMarket = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 1em;
`;
export const ColHeaderMarket = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;
export const SPCol = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
`;

export const SPRow12 = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    width: 100%;
`;
export const SPCol60 = styled.div`
    width: 100%;
    @media (min-width: 768px) {
        width: 64%;
    }
`;
export const SPColSpacer = styled.div`
  display: none;

  @media (min-width: 768px) {
    display: block;
    width: 2%;
  }
`;
export const SPCol36 = styled.div`
    width: 100%;

    @media (min-width: 768px) {
        width: 32%;
    }
`;

export const SPColDescription = styled.div`
`;
export const SPTitle = styled.p`
    margin-bottom: 8px;
    cursor: default;
    font-family: 'Barlow', sans-serif;
    color: #556769;
    font-weight: 600;
    font-size: 18px;
`;
export const SPSubTitle = styled.h4`
    text-align: center;
    margin-bottom: 24px;
    cursor: default;
    font-family: 'Barlow', sans-serif;
    color: #556769;
    font-weight: 600;
    font-size: 18px;
`;
export const SPSummary = styled.p`
    margin-bottom: 8px;
    width: 80%;
    text-align: justify;
    cursor: default;
    font-family: 'Barlow', sans-serif;
    color: #556769;
    font-size: 16px;
`;
export const SPColAnalysis = styled.div`
    width: 100%;
    display: flex;
    margin: 24px 0px;
`;
export const SPCenterContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center !important;
    align-items: center;
    margin: 24px 0px 24px 0px;
`;
export const MarketCard = styled.div`
`;
export const SPButton = styled(DefaultButton)`
    padding: 10px 20px;
    background: #CC214F;
    color: white;
    border: 1px solid #CC214F;
    border-radius: 20px;
`;
export const ErrorMessage = styled.span`
    position: absolute;
    display: block;
    width: fit-content;
    top: 83%;
    left: 0;
    margin: 0;
    color: hsl(0, 100%, 63%);
    font-size: 13px;
    font-family: 'Open Sans', sans-serif;
    font-weight: 700;
`;
export const MarketColSearchContainerInner = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    min-height: 280px;
`;
export const MarketColLastAnalyisisContainerInner = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    min-height: 280px;
`;
export const AnalisysPortfolioContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    border: 2px solid red;
`;


export const AnalyisisTableContainerInner = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: row;
`;

export const AnalyisisReportContainerInner = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
`;


export const AnalisysPortfolioTableContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
`;

export const AnalisysChatGPTContainer = styled.div`
    width:100%;
    font-family: 'Barlow', sans-serif;
    display: flex;
    flex-direction: column;
    min-width: 100%;
    padding: 0px 16px 0px 0px;
    text-align: left;
    max-height: 1190px;
    overflow-y: scroll;
    h2, h1{
        font-size: 1.3rem;
    }
`;
export const MarketSteps = styled.div`
    h3
    {
        font-size: 22px;
        color: #cc214f;
    }
    h3 span
    {
        color: #beced5;
        margin-left: 2px;
    }
`;

export const MarketArrow = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
`;

export const MarketSpacer = styled.div`
    height: 96px;
`;

export const Separator = styled.div`
    width: 100%;
    height: 1px;
    margin: 8px 0;
`;

export const MarketLineSeparator = styled.div`
    margin-top: 24px;
    margin-bottom: 24px;
    width: 100%;
    height: 1px;
    background-color: #95A0A1;
    opacity: 0.2;  
`;
export const MarketPdfViewer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .pdfSlick{
        width: 50%;
        height: 400px;
        .toolbar{display: none;}
    } 
`;

export const AnalyisisContainer = styled.div`
    margin-bottom: 24px;
    width: 100%;
    justify-content: space-between;
    display: flex;
    flex-direction: row;
`;

export const AnalyisisTableContainer = styled.div`
    width: 72%;
    display: flex;
    flex-direction: column;
    margin-right: 8px;
`;
export const AnalyisisReportContainer = styled.div`
    width: 28%;
    display: flex;
    flex-direction: column;
    margin-left: 8px;
`;

export const TitleCard = styled.div`
    padding-left: 16px;
    padding-top: 16px;
`;
export const ContainerCard = styled.div`
    min-height: 6em;
    background-color: ${props => props?.theme?.palette?.tertiary || "#e9eff1"};
    border-radius: 10px;
    width: 100%;
    margin-left: 10px;
    line-height: 16px;
    box-shadow: rgb(0 0 0 / 13%) 0px 1.6px 3.6px 0px, rgb(0 0 0 / 11%) 0px 0.3px 0.9px 0px;
    &#shared-portfolio
    {
        background: ${props => props?.theme?.palette?.themePrimary};
        color: ${props => props?.theme?.palette?.white};
        display: inline-block;
        > *:first-child
        {
            font-weight: 600;
            font-size: 20px;
            line-height: 28px;
            > h5
            {
                font-weight: 400;
                font-size: 12px;
                line-height: 16px;
            }
        }
        .separator
        {
            margin: 0 16px;
            opacity: 0.2;
        }
        .content
        {
            padding-left: 1em;
            padding-bottom: 1em;
            span
            {
                font-weight: 400;
                font-size: 14px;
                line-height: 20px;
                margin-right: 5px;
                &.value
                {
                    margin-right: 16px;
                    font-weight: 600;
                }
            }
        }
        > button
        {
            position: absolute;
            top: 5px;
            right: 5px;
            padding: 0;
            border: 0;
            background: none;
            color: ${props => props?.theme?.palette?.white};
        }
    }
`;
export const DataCard = styled.div`
    padding-top: 1.3em;
    font-size: 20px;
    float: right;
    padding-right: 8px;
    display: flex;
    width: 80%;
`;
export const DataCardContract = styled.div`
    padding-top: 1.3em;
    font-size: 20px;
    float: right;
    padding-right: 5px;
    display: block;
    width: 80%;
`;
export const DataCardMultipleContract = styled.div`
    padding-top: inherit;
    font-size: 20px;
    float: right;
    padding-right: 5px;
    display: block;
    width: 80%;
    font-weight: bold;
    position: absolute;
    bottom: 0;
    right: 0;
    padding-bottom: 7px;
`;
export const DataCardValoration = styled.div`
    padding-top: 2em;
    font-size: 1em;
    float: right;
    padding-right: 8px;
    display: flex;
    font-weight: bold;
`;
export const TitleText = styled.h5`
    margin: 0;
    text-transform: uppercase;
    font-weight: 600;
    font-size: 12px;
    cursor: default;
    color: ${props => props?.theme?.palette?.primary};
`;
export const DataText = styled.h5`
    margin: 0 !important;
    width: 100%;
    text-align: end;
    font-size: 0.75em;
    cursor: default;
`;
export const DataTextContract = styled.h5`
    padding-left: 1em;
    padding-right: 0.7em;
    margin: 0 !important;
    text-align: end;
    font-size: 0.65em;
`;
export const DataTextMultipleContract = styled.div`
    padding-left: 1em;
    margin: 0 !important;
    text-align: end;
    font-size: 0.65em;
    display: flex;
    justify-content: end;
    align-items: flex-end;
`;
export const NumberFormatDiv = styled.div`
    margin-top: -2px;
`;
export const TableBubble = styled.table`
    width: 100%;
`;
export const TRTableBubble = styled.tr`
    font-size: 18px;
`;
export const THTableBubble = styled.th`
    text-align: left;
`;
export const TDTableBubble = styled.td`
    text-align: right;
`;
export const InformationIcon = styled.div`
    margin-top: 1.5em;
    margin-left: 1em;

    @media(width: 1024px)
    {
        margin-left: 0.5em;
    }
`;
export const DivRowContract = styled.div``;
export const DivRowPosition = styled.div``;
export const DivRowRate = styled.div``;
export const DivRowPeriod = styled.div``;
export const DivRowYTD = styled.div``;
export const DivRowYear = styled.div``;
export const DivPrincipalRow = styled.div``;
export const DivContainerRow = styled.div``;
export const DivContainerCol = styled.div``;
export const DivColEmpty = styled.div``;
export const DivColSharedPortfolio = styled.div``;